<template>
    <div>
        <maincontent>
            <template v-slot:header>
                <h1>{{ $t('pages.contact.title') }}</h1>
                <p>{{ $t('pages.contact.subtitle') }}</p>
            </template>
        </maincontent>

        <contactcard></contactcard>

        <people></people>

        <locationcard></locationcard>
    </div>
</template>

<script>
import homehero from "@/components/homehero.vue";
import fullimage from "@/components/fullimage.vue";
import navigationgrid from "@/components/navigationgrid.vue";
import navigationcard from "@/components/navigationcard.vue";
import wwdfooter from "@/components/wwdfooter.vue";
import maincontent from "@/components/maincontent.vue";
import people from "@/components/people.vue";
import contactcard from "@/components/contactcard.vue";
import locationcard from "@/components/locationcard.vue";

export default {
    components: {
        homehero: homehero,
        fullimage: fullimage,
        navigationgrid: navigationgrid,
        navigationcard: navigationcard,
        wwdfooter: wwdfooter,
        maincontent: maincontent,
        people: people,
        locationcard: locationcard,
        contactcard: contactcard
    }
};
</script>
